import { render } from "./legal.vue?vue&type=template&id=5de923b0&ts=true"
import script from "./legal.vue?vue&type=script&lang=ts"
export * from "./legal.vue?vue&type=script&lang=ts"

import "./legal.vue?vue&type=style&index=0&id=5de923b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__